// HIBA-ÁLLAPOT a PARTNER-felületen — a közös `ListErrorState`, partner-hangnemben.
//
// MIÉRT KÜLÖN WRAPPER (és nem a szöveg minden hívási helyen): a belső felület TEGEZ („Váratlan hiba történt.
// Próbáld újra."), a partner-portál viszont végig ÖNÖZ. A hangnem-eltérés a lapokon szemre nem tűnik fel —
// mérve: a jegy-nyitó lap hiba-állapota tegezett, miközben körülötte minden önözött. Egy wrapper
// egy helyen dönti el a feliratot, és a hat portál-hívási hely nem ismétli a két kulcsot.
//
// A `forbidden` ág SZÁNDÉKOSAN nincs itt: a partner-felületen a 403 nem hiba-állapot, hanem SAJÁT állapot
// („nincs portál-hozzáférésed", kitől kérje) — azt a lapok külön `EmptyState`-tel mutatják.
import { useTranslation } from 'react-i18next';

import { ListErrorState } from '@/components/shared/list-error-state';

export function PortalErrorState({ onRetry }: { onRetry: () => void }): JSX.Element {
  const { t } = useTranslation();
  return (
    <ListErrorState
      forbidden={false}
      onRetry={onRetry}
      title={t('portal.loadError.title')}
      description={t('portal.loadError.desc')}
    />
  );
}
